import { create } from "zustand";

/**
 * Shared state for references sidebar filter toggles so {@link DocumentReferencesTab}
 * and dev tooling (e.g. document link injection console report) stay aligned.
 */
type ReferencesSidebarFiltersState = {
  showHistorical: boolean;
  showEarlierWorkspaceVersions: boolean;
  setShowHistorical: (value: boolean) => void;
  setShowEarlierWorkspaceVersions: (value: boolean) => void;
};

export const useReferencesSidebarFiltersStore =
  create<ReferencesSidebarFiltersState>((set) => ({
    showHistorical: true,
    showEarlierWorkspaceVersions: false,
    setShowHistorical: (showHistorical) => set({ showHistorical }),
    setShowEarlierWorkspaceVersions: (showEarlierWorkspaceVersions) =>
      set({ showEarlierWorkspaceVersions }),
  }));
